import { render } from "./EditFournisseurPage.vue?vue&type=template&id=2b31cd8a&ts=true"
import script from "./EditFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./EditFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__